import { h, Component } from 'preact';
import { Link } from 'preact-router/match';
import CartWrapper from '../shpfybtn/cartWrapper'
import Image from 'react-lazy-image';


export default class Header extends Component {
	render() {
		const { url = '', goToMerch } = this.props
		const isShop = url.includes('shop') || url.includes('collection')
		const isMusic = url.includes('/#')
		const isShows = url.includes('shows')
		return (
			<header>
			
			
				<div class="cart" >
					<CartWrapper url={url} goToMerch={goToMerch} />
				</div>
			

<div class="project_contain contain">
<div class="title_line">

</div>


</div>
<div class="clearfix"></div>
			</header>
		);
	}
}



// WEBPACK FOOTER //
// ./components/header/index.js